module.exports = __webpack_public_path__ + "static/media/IMG_20161024_214832.4f2d81f8.jpg";